import { ApplyFunction, BaseVectorFilter } from "../BaseVectorFilter";
import { SegmentFilterContext, VectorSegment } from "../VectorSprite";

/**
 * Flexible filter that takes apply functions and optional lifespan
 */
export class VectorFilter extends BaseVectorFilter {
  private applyFunctions: ApplyFunction[];

  constructor(
    applyFunctions: ApplyFunction | ApplyFunction[],
    lifespan?: number,
  ) {
    super();
    this.applyFunctions = Array.isArray(applyFunctions)
      ? applyFunctions
      : [applyFunctions];

    if (lifespan) {
      this.waitRender(lifespan).then(() => {
        this.destroy();
      });
    }
  }

  apply(
    segments: VectorSegment[],
    context: SegmentFilterContext,
  ): VectorSegment[] {
    // Apply all functions in sequence
    return this.applyFunctions.reduce(
      (result, applyFn) => applyFn(result, context),
      segments,
    );
  }
}
